'use strict';

angular.module('internal.services')
    .controller('InternalServiceTrainingReimbursement', ['$scope', '$stateParams', '$q', 'ServiceUserTrainings', 'Users', 'TrainingUsers', '$state', function ($scope, $stateParams, $q, ServiceUserTrainings, Users, TrainingUsers, $state) {
        //$scope.resetService();
        $scope.reimbursement = $stateParams.reimbursement;
        $scope.reimbursementID = $stateParams.reimbursementID;
        $scope.saving = false;
        $scope.deleting = false;
        $scope.loading = true;
        var promises = [];

        $scope.getTrainings = function () {
            $scope.loading = true;

            // Use empty Guid so no courses that are reimbursed show
            TrainingUsers.getTrainingsForReimbursement({ user_id: $scope.reimbursement.user_id, license_request_id: '00000000-0000-0000-0000-000000000000', training_id: $scope.reimbursement.training_id }).then(function (trainings) {
                $scope.trainings = trainings;
                $scope.loading = false;
            })
        }

        $scope.userChange = function () {
            $scope.reimbursement.training_id = null;
            $scope.getTrainings();
        }

        promises.push(Users.get({ service_id: $scope.serviceID, forService: true, forServiceLookup: true}).then(function (service_users) {
            $scope.service_users = service_users;
        }))

        if ($stateParams.reimbursementID != null) {
            promises.push(ServiceUserTrainings.getByID($stateParams.reimbursementID).then(function (reimbursement) {
                $scope.reimbursement = reimbursement;
                $scope.getTrainings();
            }))
        }
        else {
            $scope.reimbursement = { service_id: $scope.serviceID };
            $q.all(promises).then(function () {
                $scope.loading = false;
            }).catch(function (response) {
                // handle error
            });
        }

        $scope.save = function () {
            $scope.saving = true;

            ServiceUserTrainings.save($scope.reimbursement).then(function () {
                $scope.saving = false;
                $state.go('internal.licensing.service.reimbursements', { id: $scope.serviceID });
            });
        }

        $scope.delete = function () {
            $scope.deleting = true;

            if (window.confirm('Are you sure you want to delete this course reimbursement?')) {
                ServiceUserTrainings.delete($scope.reimbursementID).then(function () {
                    $scope.deleting = false;
                    $state.go('internal.licensing.service.reimbursements', { id: $scope.serviceID });
                })
            }
            else {
                $scope.deleting = false;
            }
        }
    }])
;